import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      color: 'white',
      fontSize: 'sm',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      fontFamily: 'accent',
      '&&': {
        border: 'none',
        borderRightRadius: 'base',
        borderLeft: 'none',
        bg: 'alpha.700',
      },

      '&::placeholder': {
        color: 'gray.400',
      },

      '&:hover': {
        '&&': {
          bg: 'alpha.800',
          border: 'none',
          borderLeft: 'none',
          color: 'alpha.200',
        },
      },

      '&:focus, &:active': {
        '&&': {
          bg: 'alpha.800',
          border: 'none',
          color: 'beta.300',
          boxShadow: 'none',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'bold',
      fontSize: 'md',
      fontFamily: 'accent',

      '&&': {
        bgGradient: 'linear(to-b, beta.300, beta.400)',
        color: 'beta.500',
        textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
        borderLeftRadius: 'base',
        border: 'none',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          '&&': {
            boxShadow: 'none',
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {
    size: 'md',
  },
};
